import { render } from "./Kwaliteit.vue?vue&type=template&id=3d813b1c&scoped=true"
const script = {}

import "./Kwaliteit.vue?vue&type=style&index=0&id=3d813b1c&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\reino\\Desktop\\testt\\de-tol\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d813b1c"]])

export default __exports__